<div class="modal-header">
    <h4 class="modal-title">Sager der er godkendt af KA, men du mangler at godkende som LA</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <table class="table table-hover table-striped table-sm">
        <thead>
            <th scope="col">Sag</th>
            <th scope="col">Kundenr</th>
            <th scope="col">Navn</th>
            <th scope="col">KA Godkendt</th>
        </thead>
        <tbody>
            <tr *ngFor="let client of kalas"
            class="clickable"
            (click)="onGotoSag(client)">
                <td>{{client?.beskrivelse}}</td>
                <td>{{client.glkundenr}}</td>
                <td>{{client.navn1}}</td>
                <td>{{client.konklusionDen | date:'dd-MM-yyyy'}}</td>
            </tr>
        </tbody>
    </table>
</div>
